import { Block } from '@core/models/block/block.model';
import { isSpecialBlock } from '@shared/helpers/block-helpers';

type Styles = Pick<Block, 'uId' | 'styles' | 'modelId'>;
export const createStyleRecursive = (children: Block[]): Styles[] => {
  const blocks: Styles[] = [];
  if (typeof children[Symbol.iterator] === 'function') {
    for (const blk of children) {

      if (blk.children?.length > 0) {
        // parent
        const styles: Styles = {
          uId: blk.uId,
          modelId: blk.modelId,
          styles: blk.styles,
        };
        // children
        const _children = createStyleRecursive(blk.children);
        blocks.push(styles, ..._children);
      } else {
        // special block children
        if (isSpecialBlock(blk)) {
          // parent
          const specialBlockStyles: Styles = {
            uId: blk.specialBlock.uId,
            styles: blk.specialBlock.styles,
            modelId: null
          };
          const _children = createStyleRecursive(blk.specialBlock.children);
          blocks.push(specialBlockStyles, ..._children);
        }

        const styles: Styles = {
          uId: blk.uId,
          modelId: blk.modelId,
          styles: blk.styles,
        };

        blocks.push(styles);
      }
    }
  }
  return blocks;
};

export const getBgSizeForAnimationName = (name: string) => {
  if (['bgMoveFromTopLeftCorner', 'bgMoveHorizontal', 'bgMoveVertical'].includes(name)) {
    return 'var(--bgMoveAnimationBgSize)';
  }
  if (['bgSizeUp', 'bgSizeDown'].includes(name)) {
    return `var(--${name}BgSizeEnd)`;
  }
  return null;
};

export const isTextGradientBackground = (basic: Record<string, any> | undefined): boolean => {
  return basic?.backgroundClip === 'text' || basic?.['-webkitBackgroundClip'] === 'text';
};

export const hasParallax = (basic: Record<string, any> | undefined): boolean => {
  return +(basic?.['--paralaxSpeed'] || 0) !== 0;
};
